import { AppItem } from '@/model/definitions'
import Vue, { VNode } from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import $style from './index.module.scss'

@Component
export default class extends Vue {
  @Prop({
    default: () => ({})
  })
  private readonly model!: AppItem

  @Prop(String) private readonly size?: string
  @Prop({
    type: Boolean,
    default: true
  })
  private readonly canFav?: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  private readonly removeBtn!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  private readonly disable!: boolean

  private get isNotDing() {
    return !this.model.appName.includes('钉钉')
  }

  @Emit('click')
  private itemClick(): AppItem {
    return this.model
  }

  get sizeStyle(): string {
    return this.size
      ? (this.size === 'small' ? ` ${$style.small_item}` : '')
      : ''
  }

  @Emit('fav')
  private favClick(e: Event): AppItem {
    e.stopPropagation()
    return this.model
  }

  @Emit('remove')
  private remove(e: Event): AppItem {
    e.stopPropagation()
    return this.model
  }

  render(): VNode | null {
    return this.isNotDing ? <div class={`${$style.component_app_item}${this.sizeStyle}${this.disable ? ' disable-item' : ''}`} onClick={this.itemClick}>
      <div class="app-icon">
        {
          this.model.avatarUrl && <img v-lazy={this.model.avatarUrl} alt="" />
        }
      </div>
      <div class="app-name">
        { this.model.appName }
        {
          this.model.subName && (
            <span>{ this.model.subName }</span>
          )
        }
      </div>
      {
        this.canFav &&
          <div class="app-actions">
            <i class='el-icon-star-off' onClick={ this.favClick }></i>
          </div>
      }
      <div class="app-actions">
        {
          this.canFav && <i class='el-icon-star-off' onClick={ this.favClick }></i>
        }
        {
          this.removeBtn && <i class='el-icon-star-on my-faved' onClick={ this.remove }></i>
        }
      </div>
    </div> : null
  }
}
